var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{staticClass:"banner",attrs:{"src":_vm.image,"alt":"","src-placeholder":_vm.holderimg}})
}
var staticRenderFns = []

export { render, staticRenderFns }